import { ComponentNames } from "../../constant/component-constant";
import { logAdapterEvent, logError } from "../../helper/logger";
import { createPackageOrderMap } from "../../helper/genre-helper";
import { pickChannels } from "../../helper/channels-service-helpers";
import { IPackageConfig } from "../../types/global";
import { SatelliteBasePlan, SatelliteAddon } from "../../types/epoch";

const ADAPTER_NAME = "DtvAgentPackageCompareTool";

// Generated by Copilot- Start - 2026-03-17 19:05:13
/**
 * Merges base packageConfig fields with any CMS overrides from content.packageData,
 * keyed by the package's queryparam. Normalises packageId and packageName for
 * consistent downstream consumption.
 */
const buildPackageData = (pkg: any, packageData: any) => {
  const cmsOverrides = packageData?.[pkg?.queryparam] ?? {};

  return {
    // Start with the base package fields
    ...pkg,
    // Apply CMS overrides on top of base package fields
    ...cmsOverrides,
    // Finally, normalise identifiers so they cannot be overridden
    packageId: pkg?.id,
    packageName: pkg?.displayLabel || pkg?.epochPackageName
  };
};
// Generated by Copilot- End - 2026-03-17 19:05:13

interface DtvAgentPackageCompareToolAdapter {
    content: any;
    channelListingData?: any;
    channelsServiceData?: any;
    rsnTierLegalText?: any;
    genreLocalChannelMapping?: any;
    signatureExcludedLocalChannels?: any[];
    embeddedSvods?: any;
    embeddedIncludedSvods?: any;
    getOffersGenreData?: any;
    offerPrices?: any;
    genreNationals?: any;
    packageConfig?: IPackageConfig[];
    satelliteBasePlans?: SatelliteBasePlan[];
    satelliteAddonsByBP?: Record<string, SatelliteAddon[]>;
}

export const dtvAgentPackageCompareToolAdapter = ({
  content,
  channelListingData,
  channelsServiceData,
  rsnTierLegalText,
  genreLocalChannelMapping,
  signatureExcludedLocalChannels,
  embeddedSvods,
  embeddedIncludedSvods,
  getOffersGenreData,
  offerPrices,
  genreNationals,
  packageConfig,
  satelliteBasePlans,
  satelliteAddonsByBP
}: DtvAgentPackageCompareToolAdapter): any => {
  try {
    logAdapterEvent(ADAPTER_NAME, "dtvAgentPackageCompareToolAdapter", { content });
    // Generated by Copilot- Start - 2026-03-17 19:05:13
    const packageOrderMap = createPackageOrderMap(packageConfig);
    const sortByOrder = (a: any, b: any) => (packageOrderMap?.[a.id] ?? Infinity) - (packageOrderMap?.[b.id] ?? Infinity);

    const filterSortMap = (type: string) => (packageConfig || [])
      .filter((pkg: any) => pkg.type === type)
      .map((pkg: any) => buildPackageData(pkg, content?.packageData))
      .sort(sortByOrder);

    const miniPackages = filterSortMap("genre-mini");
    const genrePackages = filterSortMap("genre");
    const internetPackagesConfig = filterSortMap("internet");
    // Generated by Copilot- End - 2026-03-17 19:05:13
    return {
      props: {
        ...content,
        ...(internetPackagesConfig?.length > 0 && {signaturePackagesConfig: internetPackagesConfig}),
        ...(miniPackages?.length > 0 && {miniPackages: miniPackages}),
        ...(genrePackages?.length > 0 && {genrePackages: genrePackages}),
        channels: pickChannels(channelsServiceData?.channels, channelListingData?.[":items"]?.chnlListingPageData?.elements?.channels),
        rsnTierLegalText: rsnTierLegalText?.[0]?.stream || {},
        genreLocalChannelMapping,
        signatureExcludedLocalChannels,
        embeddedSvods,
        embeddedIncludedSvods,
        getOffersGenreData,
        offerPrices,
        rsnFee: offerPrices?.rsnFee,
        geminiFee: offerPrices?.geminiFee,
        genreNationals,
        satelliteBasePlans,
        satelliteAddonsByBP
      },
      type: ComponentNames.DTVAGENTPACKAGECOMPARETOOL
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      message: "Error in dtvAgentPackageCompareToolAdapter"
    });
  }
}

export default dtvAgentPackageCompareToolAdapter;
